var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetaBaixo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "233pt",
    height: "220pt",
    viewBox: "0 0 233 220",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#837d88ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "#2369ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2369ff",
    opacity: 1,
    d: " M 94.09 15.62 C 124.83 9.48 158.44 19.11 180.72 41.26 C 177.30 41.53 173.88 41.64 170.47 41.95 C 153.11 27.73 130.40 20.23 107.98 21.54 C 89.81 22.42 72.11 29.13 57.64 40.10 C 54.66 38.27 50.84 40.94 48.29 38.31 C 60.98 26.64 77.23 18.99 94.09 15.62 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "#b12cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b12cff",
    opacity: 1,
    d: " M 55.44 52.28 C 76.98 30.59 111.35 23.26 140.06 33.55 C 151.42 37.50 161.95 43.91 170.56 52.31 C 167.08 53.11 163.50 53.69 159.95 52.97 C 146.23 41.96 128.56 36.05 110.98 36.58 C 94.50 36.94 78.22 42.91 65.40 53.27 C 62.05 53.44 58.56 53.80 55.44 52.28 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "#395fffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#395fff",
    opacity: 1,
    d: " M 48.14 38.21 L 48.29 38.31 C 50.84 40.94 54.66 38.27 57.64 40.10 C 51.10 45.33 45.06 51.22 40.07 57.96 C 37.26 57.70 34.46 57.38 31.66 57.10 C 36.00 49.95 41.85 43.71 48.14 38.21 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "#3d5effff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3d5eff",
    opacity: 1,
    d: " M 170.47 41.95 C 173.88 41.64 177.30 41.53 180.72 41.26 C 188.39 47.94 194.41 56.53 199.42 65.39 C 197.35 67.29 194.29 66.59 191.76 67.10 C 186.25 57.51 178.89 49.08 170.47 41.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d5eff",
    opacity: 1,
    d: " M 49.30 165.94 C 51.14 163.99 53.54 162.81 56.20 162.46 C 61.05 168.06 66.90 172.74 73.12 176.74 C 69.98 176.70 67.57 178.55 65.67 180.84 C 59.53 176.70 54.07 171.58 49.30 165.94 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "#9b35ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b35ff",
    opacity: 1,
    d: " M 55.26 52.23 L 55.44 52.28 C 58.56 53.80 62.05 53.44 65.40 53.27 C 58.98 58.58 53.29 64.82 48.86 71.89 C 46.06 72.60 42.85 73.55 40.51 71.24 C 44.35 64.16 49.43 57.77 55.26 52.23 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b35ff",
    opacity: 1,
    d: " M 170.56 52.31 L 170.72 52.29 C 176.85 58.55 182.63 65.45 186.32 73.45 C 183.93 75.35 181.03 72.82 178.79 74.97 C 173.98 66.51 167.48 59.10 159.95 52.97 C 163.50 53.69 167.08 53.11 170.56 52.31 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "#4859ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4859ff",
    opacity: 1,
    d: " M 31.35 57.10 L 31.66 57.10 C 34.46 57.38 37.26 57.70 40.07 57.96 C 36.37 63.00 33.10 68.36 30.43 74.01 C 27.94 73.35 25.40 72.93 22.84 72.65 C 25.14 67.20 28.14 62.06 31.35 57.10 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "#ddadffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ddadff",
    opacity: 1,
    d: " M 101.63 62.04 C 102.08 60.09 104.14 59.06 106.02 59.24 C 111.22 59.36 116.46 58.97 121.64 59.44 C 126.08 61.57 123.64 67.42 124.21 71.28 C 116.71 69.78 109.06 71.10 101.54 69.88 C 101.51 67.27 101.37 64.64 101.63 62.04 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "#5056ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5056ff",
    opacity: 1,
    d: " M 199.42 65.39 C 202.56 71.24 205.24 77.36 207.10 83.74 C 204.51 83.12 201.89 83.61 199.55 84.81 C 197.58 78.65 194.79 72.80 191.76 67.10 C 194.29 66.59 197.35 67.29 199.42 65.39 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5056ff",
    opacity: 1,
    d: " M 182.67 141.80 C 185.23 141.80 188.37 140.47 190.44 142.60 C 188.48 147.95 185.64 152.91 182.74 157.80 L 182.50 157.74 C 179.98 156.99 177.43 156.31 174.85 155.79 C 177.89 151.38 180.48 146.69 182.67 141.80 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "#ccb1ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccb1ff",
    opacity: 1,
    d: " M 101.54 69.88 C 109.06 71.10 116.71 69.78 124.21 71.28 C 124.29 77.62 124.25 83.96 124.22 90.31 C 116.68 91.57 109.06 89.92 101.53 90.72 C 101.52 83.77 101.43 76.83 101.54 69.88 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "#8c3cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8c3cff",
    opacity: 1,
    d: " M 33.32 88.30 C 34.82 82.33 37.25 76.47 40.51 71.24 C 42.85 73.55 46.06 72.60 48.86 71.89 C 45.59 77.03 42.97 82.56 41.02 88.33 C 38.47 88.74 35.87 88.73 33.32 88.30 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "#5553ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5553ff",
    opacity: 1,
    d: " M 17.54 87.89 C 18.85 82.67 20.54 77.51 22.84 72.65 C 25.40 72.93 27.94 73.35 30.43 74.01 C 28.41 78.68 26.54 83.43 25.20 88.34 C 22.64 88.30 20.09 88.10 17.54 87.89 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "#8a3dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a3dff",
    opacity: 1,
    d: " M 178.79 74.97 C 181.03 72.82 183.93 75.35 186.32 73.45 L 186.60 73.36 C 189.37 79.01 191.93 84.82 193.36 90.98 C 190.82 91.26 188.28 91.40 185.73 91.38 C 183.98 85.69 181.65 80.19 178.79 74.97 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "#5f4fffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5f4fff",
    opacity: 1,
    d: " M 199.55 84.81 C 201.89 83.61 204.51 83.12 207.10 83.74 C 208.71 89.54 210.43 95.56 210.47 101.57 C 207.97 101.34 205.51 101.80 203.30 103.00 C 202.67 96.82 201.35 90.74 199.55 84.81 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "#624effff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#624eff",
    opacity: 1,
    d: " M 17.54 87.89 C 20.09 88.10 22.64 88.30 25.20 88.34 C 23.85 93.48 22.89 98.71 22.38 103.99 C 19.94 103.33 17.46 102.78 14.94 102.55 C 15.42 97.61 16.22 92.68 17.54 87.89 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "#7e42ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7e42ff",
    opacity: 1,
    d: " M 33.08 88.27 L 33.32 88.30 C 35.87 88.73 38.47 88.74 41.02 88.33 C 39.31 93.72 38.05 99.27 37.50 104.91 C 34.96 104.72 32.40 104.75 29.90 105.29 C 30.35 99.53 31.46 93.82 33.08 88.27 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "#b1b7ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b1b7ff",
    opacity: 1,
    d: " M 101.53 90.72 C 109.06 89.92 116.68 91.57 124.22 90.31 C 124.22 99.56 124.40 108.83 124.12 118.07 C 117.24 118.04 110.35 118.23 103.49 118.15 C 103.00 117.91 102.02 117.43 101.53 117.19 C 101.50 108.37 101.45 99.54 101.53 90.72 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "#7b43ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7b43ff",
    opacity: 1,
    d: " M 185.73 91.38 C 188.28 91.40 190.82 91.26 193.36 90.98 C 195.00 96.62 195.79 102.50 196.07 108.37 C 193.54 108.59 191.00 108.50 188.50 108.03 C 188.19 102.40 187.20 96.82 185.73 91.38 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "#6e49ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6e49ff",
    opacity: 1,
    d: " M 203.30 103.00 C 205.51 101.80 207.97 101.34 210.47 101.57 L 210.84 101.84 C 211.21 107.13 211.55 112.44 211.15 117.74 C 208.59 118.06 206.05 118.43 203.53 118.94 C 203.94 113.63 203.77 108.30 203.30 103.00 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "#7048ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7048ff",
    opacity: 1,
    d: " M 14.94 102.55 C 17.46 102.78 19.94 103.33 22.38 103.99 C 21.96 109.02 21.87 114.07 22.25 119.11 C 19.75 119.47 17.22 119.64 14.71 119.37 C 14.35 113.77 14.36 108.13 14.94 102.55 Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "#6f48ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6f48ff",
    opacity: 1,
    d: " M 29.90 105.29 C 32.40 104.75 34.96 104.72 37.50 104.91 C 37.01 110.18 37.05 115.49 37.60 120.76 C 35.11 121.09 32.62 121.37 30.12 121.43 C 29.48 116.08 29.45 110.66 29.90 105.29 Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "#6c4affff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c4aff",
    opacity: 1,
    d: " M 188.50 108.03 C 191.00 108.50 193.54 108.59 196.07 108.37 C 196.35 114.68 195.90 121.00 194.93 127.24 L 194.50 127.14 C 192.18 126.48 189.83 125.94 187.48 125.45 C 188.46 119.71 188.82 113.85 188.50 108.03 Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "#96bdffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#96bdff",
    opacity: 1,
    d: " M 101.53 117.19 C 102.02 117.43 103.00 117.91 103.49 118.15 C 110.35 118.23 117.24 118.04 124.12 118.07 C 124.21 118.52 124.38 119.41 124.47 119.86 C 129.64 119.96 134.82 119.76 139.99 119.94 C 142.91 120.39 144.16 124.18 142.26 126.37 C 138.69 131.90 135.39 137.63 131.54 142.96 C 123.31 141.84 114.99 143.11 106.73 142.61 C 102.64 142.68 98.22 141.38 94.44 143.50 C 90.57 137.67 86.87 131.71 83.16 125.78 C 81.54 123.59 83.41 120.23 85.96 119.94 C 91.13 119.73 96.31 120.03 101.47 119.80 C 101.49 119.15 101.52 117.84 101.53 117.19 Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "#7c43ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7c43ff",
    opacity: 1,
    d: " M 203.53 118.94 C 206.05 118.43 208.59 118.06 211.15 117.74 C 210.82 122.78 210.35 127.87 209.12 132.79 C 206.45 132.85 203.77 133.04 201.19 133.75 C 202.39 128.89 203.11 123.92 203.53 118.94 Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "#8240ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8240ff",
    opacity: 1,
    d: " M 14.71 119.37 C 17.22 119.64 19.75 119.47 22.25 119.11 C 22.89 127.86 24.92 136.45 27.96 144.67 C 25.47 144.85 23.01 145.25 20.57 145.72 L 20.28 145.76 C 17.25 137.27 15.34 128.37 14.71 119.37 Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "#5e50ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5e50ff",
    opacity: 1,
    d: " M 30.12 121.43 C 32.62 121.37 35.11 121.09 37.60 120.76 C 38.65 129.41 41.06 137.91 44.97 145.72 C 42.38 145.86 39.83 146.46 37.70 148.00 C 33.65 139.68 31.08 130.63 30.12 121.43 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5e50ff",
    opacity: 1,
    d: " M 182.67 141.80 C 184.79 136.52 186.46 131.06 187.48 125.45 C 189.83 125.94 192.18 126.48 194.50 127.14 C 194.33 132.43 192.23 137.61 190.44 142.60 C 188.37 140.47 185.23 141.80 182.67 141.80 Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "#883dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#883dff",
    opacity: 1,
    d: " M 201.19 133.75 C 203.77 133.04 206.45 132.85 209.12 132.79 C 208.04 137.95 206.66 143.09 204.58 147.94 C 202.01 147.67 199.44 147.35 196.89 146.94 C 198.66 142.66 200.07 138.24 201.19 133.75 Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "#82c2ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#82c2ff",
    opacity: 1,
    d: " M 94.44 143.50 C 98.22 141.38 102.64 142.68 106.73 142.61 C 114.99 143.11 123.31 141.84 131.54 142.96 C 129.67 146.46 127.51 149.88 125.15 153.09 C 117.00 153.07 108.85 152.40 100.71 153.31 C 98.44 150.17 96.45 146.81 94.44 143.50 Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "#9538ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9538ff",
    opacity: 1,
    d: " M 20.57 145.72 C 23.01 145.25 25.47 144.85 27.96 144.67 C 30.13 150.27 32.92 155.62 36.05 160.74 C 34.14 162.44 32.28 164.20 30.49 166.03 C 26.43 159.71 22.62 152.94 20.57 145.72 Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "#4b58ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4b58ff",
    opacity: 1,
    d: " M 37.70 148.00 C 39.83 146.46 42.38 145.86 44.97 145.72 C 47.92 151.78 51.78 157.37 56.20 162.46 C 53.54 162.81 51.14 163.99 49.30 165.94 C 44.56 160.60 40.73 154.46 37.70 148.00 Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "#9737ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9737ff",
    opacity: 1,
    d: " M 196.89 146.94 C 199.44 147.35 202.01 147.67 204.58 147.94 C 202.11 154.63 198.76 161.00 194.71 166.85 C 191.98 165.87 189.08 165.03 186.21 165.90 C 190.43 159.98 194.19 153.70 196.89 146.94 Z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "#77c5ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#77c5ff",
    opacity: 1,
    d: " M 100.71 153.31 C 108.85 152.40 117.00 153.07 125.15 153.09 C 123.41 156.28 121.44 159.38 119.30 162.32 C 116.13 166.45 109.01 166.22 106.09 161.93 C 104.27 159.07 102.31 156.29 100.71 153.31 Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "#425cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#425cff",
    opacity: 1,
    d: " M 155.72 174.71 C 163.11 169.55 169.63 163.13 174.85 155.79 C 177.43 156.31 179.98 156.99 182.50 157.74 C 178.28 164.51 172.92 170.65 166.74 175.72 L 166.67 175.69 C 163.34 173.63 159.38 174.50 155.72 174.71 Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "#a332ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a332ff",
    opacity: 1,
    d: " M 30.49 166.03 C 32.28 164.20 34.14 162.44 36.05 160.74 C 39.47 166.18 43.53 171.18 47.94 175.84 C 44.72 174.36 42.93 177.66 41.44 179.89 C 37.33 175.67 33.68 170.98 30.49 166.03 Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "#a830ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a830ff",
    opacity: 1,
    d: " M 186.21 165.90 C 189.08 165.03 191.98 165.87 194.71 166.85 C 189.48 174.74 183.15 182.03 175.71 187.88 C 173.00 185.41 169.29 187.58 166.33 185.75 C 173.86 180.14 180.65 173.49 186.21 165.90 Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "#2f64ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2f64ff",
    opacity: 1,
    d: " M 155.72 174.71 C 159.38 174.50 163.34 173.63 166.67 175.69 C 152.45 188.07 133.74 195.17 114.89 195.55 C 97.46 196.08 79.99 190.76 65.67 180.84 C 67.57 178.55 69.98 176.70 73.12 176.74 C 83.16 182.79 94.53 186.80 106.26 187.70 C 123.59 189.31 141.41 184.63 155.72 174.71 Z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "#b02cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b02cff",
    opacity: 1,
    d: " M 41.44 179.89 C 42.93 177.66 44.72 174.36 47.94 175.84 C 53.60 181.55 59.99 186.51 66.88 190.65 C 64.57 191.97 62.59 193.74 60.79 195.67 C 53.61 191.45 47.18 185.92 41.44 179.89 Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "#bf26ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf26ff",
    opacity: 1,
    d: " M 105.98 202.88 C 127.28 204.58 149.11 198.40 166.33 185.75 C 169.29 187.58 173.00 185.41 175.71 187.88 C 158.92 202.21 137.03 210.27 114.99 210.71 C 95.99 211.09 76.78 206.00 60.79 195.67 C 62.59 193.74 64.57 191.97 66.88 190.65 C 78.77 197.62 92.24 201.87 105.98 202.88 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaBaixo);
export default __webpack_public_path__ + "static/media/seta-baixo.ec245a4b78fa0d453f4488de6c824716.svg";
export { ForwardRef as ReactComponent };